import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  @Input() headerMessage: string;
  @Input() showCancel = true;
  @Input() message: string;
  @Output() confirm = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  @ViewChild('confirm') confirmModal: ElementRef;

  modalRef: NgbModalRef;

  constructor(private modal: NgbModal) {}

  onConfirm(): void {
    this.modalRef.close();
    this.confirm.emit();
  }

  onClose(): void {
    this.closeModal.emit();
  }

  open(): void {
    this.modalRef = this.modal.open(this.confirmModal, { centered: true });
  }
}
